<template>
  <div class="purchase-page" v-show="modules.length">

    <mt-header fixed title="购买服务" style="background:#3189FF;color:#ffffff;">
      <mt-button icon="back" slot="left" @click="goBack"></mt-button>
    </mt-header>

    <div class="scroll-wrapper">
      <div class="scroll-content">
        <div class="goods_intro">
          <img :src="goods.thumb" :alt="goods.title" class="good_pic">
          <div class="goods_detail">
            <div class="l-1">
              <span class="title">{{goods.description}}</span>
              <span class="price">¥{{goods.e2}}</span>
            </div>
            <span class="sence">{{goods.e9}}</span>
          </div>
        </div>

        <div class="combo_select" v-for="(item,index) in modules" :key="index">
          <h3>{{item.title}}</h3>
          <div v-for="value in item.modules" :key="value.id" :class="{'selected':value.id == mid}" @click="selectServer(value)">
            <span>{{value.name}}</span>
            <span class="price">
              <span>¥{{value.price}}</span>
              <img src="../assets/images/orderdetails_icon_success_26x26_@3x.png" alt="选中" class="select_img">
              <img src="../assets/images/paytypenor_20x20_@3x.png" alt="未选择" class="no_select_img">
            </span>
          </div>
        </div>

        <div class="common-wrapper modules m-b-10">
          <div class="title">
            <span class="item">
              <img src="../assets/images/global_explain@3x.png" alt="服务说明">
              服务说明
            </span>
          </div>
          <div class="content">
            {{des.description}}
          </div>
        </div>

        <div class="common-wrapper promise m-b-10">
          <div class="title">
            <span class="item">
              <img src="../assets/images/global_doublepay@3x.png" alt="双倍赔付承诺">
              双倍赔付承诺
            </span>
            <!-- <span class="detail" @click="goArticle(primary_url,'双倍赔付承诺说明')">详细标准</span> -->
          </div>
          <div class="content">
            凡通过我们没能恢复成功，通过其他渠道成功恢复的，凭相关凭证，我们双倍退款，并免费赠送数据恢复软件一套。
          </div>
        </div>

        <div class="common-wrapper team">
          <div class="title">
            <span class="item">
              <img src="../assets/images/buy_team@3x.png" class="img" alt="团队介绍">
              团队介绍
            </span>
            
          </div>
          <div class="content">
            果师兄工程师团队拥有30名经验丰富的研发和数据恢复人员，具有完善的数据分析设备和流程体系；公司复人员，具有完善的数据分析设备和流程体系；公司居于领先地位，现已服务百万级用户，用户遍布全国34个省、市、自治区、特别行政区。
            <ul class="icons">
              <li @click="goArticle(flow_url,'服务流程')">
                <img src="../assets/images/buy_process@3x.png" alt="服务流程">服务流程
              </li>
              <li @click="goArticle(question_url,'常见问题')">
                <img src="../assets/images/buy_ask@3x.png" alt="常见问题">常见问题
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    

    <div class="footer">
      <div class="price" @click="orderNow">
        立即下单
      </div>
      <div class="fee">
        <div class="consultation" @click="openQiyu" v-if="allow_chat == 1">
          <img src="../assets/images/global_footer_consult@3x.png">
          <span>咨询</span>
        </div>
        <div class="content">
          <span>支付金额：</span>
          <span>¥{{des.price}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Popup} from 'mint-ui';
export default {
    name:"purchase",//购买服务
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            goods:{},
            modules:[],
            popupVisible:false,
            mIndex:0,//选中的index
            mid:"",//选中的id
            gid: '',
            questions:[],
            des:{},//描述对象
            allow_chat: 0,
            app_id: window.config.appid,
            primary_url: window.config.API_URL1+'/apph5/page/guarantee?app_id='+window.config.appid,
            flow_url: window.config.API_URL1+'/apph5/page/summary?app_id='+window.config.appid,
            question_url: window.config.API_URL1+'/apph5/page/question?app_id='+window.config.app_id
        }
    },
    methods:{
        goArticle(url,title){
          if(title == '双倍赔付承诺说明'){
            this.sa_m_click_promise_detail(window.location.href)
          }
          this.$router.push({name:"article",query:{url:url,title:title}})
        },
        openQiyu(){
          this.sa_m_consult_button()
          var config = {
            uid: localStorage.kxuid,
            name: localStorage.nickname,
            mobile: localStorage.phone,
            success: function(){     // 成功回调
                ysf.open();
            },
            error: function(){       // 错误回调
                // handle error
            }
          };
          ysf.config(config);
        },
        goBack(){
          history.go(-1)
        },
        popBuy() {
            this.popupVisible = true;

            _taq.push(['setReferrerUrl',  ""]);
            _taq.push(['setCustomUrl', window.location.href+'?event_id=m.gsx.purchase_service']);
            _taq.push(['setDocumentTitle', "点击事件-购买服务"]);
            //追踪命令
            _taq.push(['trackPageView']);
        },
        getQuestions(){
            var vm = this;
            this.$store.dispatch("getGoodsInfo",{gid:this.gid,api_version:window.config.api_version}).then((res)=>{
                let data = res.data;
                if(data.code == 0){
                   vm.goods = data.res.data.goods;
                   vm.modules = data.res.data.groups.reverse();/*modules*/
                   vm.mid = vm.modules[0].modules[0].id;
                   vm.des = vm.modules[0].modules[0];
                   vm.questions = data.res.data.questions;
                }
            })
        },
        selectServer(value){
            this.mid = value.id;
            this.des = value;
            let arr = value.name.split('（')
            this.sa_m_package_selected(
              arr[0],
              true,
              this.goods.description
            )
            _taq.push(['setReferrerUrl',  ""]);
            _taq.push(['setCustomUrl', window.location.href+'?event_id=m.gsx.choose_package&model_id='+value.id]);
            _taq.push(['setDocumentTitle', "点击事件-选择套餐："+value.id]);
            //追踪命令
            _taq.push(['trackPageView']);
        },
        orderNow(){
          this.sa_m_purchase_goods(
            this.goods.description,
            window.location.href
          )
          localStorage.primary_mid = this.mid
          localStorage.primary_gid = this.gid
          if(this.validToken('confirmOrder','立即下单按钮')){
            let goodsName = this.goods.description;
            let temp = this.des.name.split('（');
            let packageName = temp[0]
            let goodsCategory = this.goods.category==="1"?"数据恢复服务":"综合服务";
            this.sa_m_submit_order(
              this.des.price,
              localStorage.kxuid,
              goodsName,
              goodsCategory,
              packageName,
              window.location.href,
              []
            )
            var vm = this;
            this.$router.push({name:'confirmOrder',query:{mid:vm.mid,gid:vm.gid}})
          }
        },
        goQuestionnaire(){
            sessionStorage.removeItem('batch_id');
            sessionStorage.removeItem('ghash');
            sessionStorage.removeItem('qtype');
            sessionStorage.removeItem('answer');
            sessionStorage.ghash =  sessionStorage.ghash_home;//进入深度检测就删除之前的答案 id
            let gid_ = this.$route.params.gid;
            this.$router.push({name:"questionnaire",params:{gid:gid_}})
      }
    },
    created(){
        localStorage.removeItem('purchase_mid')
        localStorage.removeItem('purchase_gid')

        this.gid = this.$route.query.gid
        this.allow_chat = this.$route.query.allow_chat

        if(!this.gid){
            this.$router.replace({name:"home"});
        }else{
            this.getQuestions();
        }
    },
    mounted(){
    },
    components:{
        Popup
    }

}
</script>

<style lang="scss" scoped="" type="text/css">

  
</style>



// WEBPACK FOOTER //
// src/components/PurchaseService.vue